<div class="status">
  <div [class]="getStatusClass() + ' px-2 py-2 color-secondary gap-2 d-flex align-items-center'">
    <svg-icon [key]="getStatusIcon()" fontSize="24px"></svg-icon>
    <span>Status: </span>
    <span class="text-normal-bold">{{ status }}</span>
  </div>
</div>
